import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactLoading from 'react-loading';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { Container, Box, TextField, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash/debounce';

import Page from '../../Page';
import { fetchSalesResultsGroups, setFilteredSalesGroups, setSalesGroupsLoading, clearSelectedCatalogs } from '../../../modules/reports/thunks';
import CatalogsGroups from './CatalogsGroups';
import ViewSelectedResultsButton from './ViewSelectedResultsButton';

const SessionResults = () => {
  const dispatch = useDispatch();
  const listRef = useRef();
  const searchRef = useRef();
  const [searchString, setSearchString] = useState('');
  const { houseRef } = useSelector(state => state.house);
  const { groups, filteredGroups, isLoadingGroups, selectedCatalogOptions } = useSelector(state => state.reports);
  const user = useSelector(state => state.user);

  const itemCount = filteredGroups?.length || 0;

  useEffect(() => {
    if (houseRef && !groups) {
      dispatch(fetchSalesResultsGroups(houseRef));
    }
  }, [houseRef, groups]);

  const handleClearSearch = () => {
    setSearchString('');
    searchRef.current.value = '';
  };

  const handleSearch = debounce((val) => {
    dispatch(setSalesGroupsLoading(true));
    const searchVal = val.toString().toLowerCase();
    setSearchString(searchVal);
  }, 300);

  useEffect(() => {
    dispatch(setSalesGroupsLoading(true));

    if (groups !== undefined && groups.length > 0) {
      const filteredArray = [];
      groups.forEach(group => {
        let includeThisGroup = false;
        if (group.groupName.toLowerCase().includes(searchString)) {
          includeThisGroup = true;
        } else {
          group.catalogs.forEach(catalog => {
            if (catalog.catalogTitle.toLowerCase().includes(searchString)) {
              includeThisGroup = true;
            }
          });
        }

        if (includeThisGroup) filteredArray.push(group);
      });
      dispatch(setFilteredSalesGroups(filteredArray));
    }
  }, [searchString]);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.resetAfterIndex(0);
    }
  }, [listRef, filteredGroups]);

  useEffect(() => {
    if (Object.keys(user).length > 0 && user.accessReports !== 1) {
      window.location.href = '/?p=1';
    }
  }, [user]);

  const clearSelectedResults = () => {
    dispatch(clearSelectedCatalogs());
  };

  return (
    <Page header={{ title: 'Sales Results' }}>
      <Container disableGutters maxWidth={false}>
        {isLoadingGroups ? (
          <ReactLoading className="loading-spinner" type="spin" height="auto" color="black" />
        ) : (
          <>

            <Box sx={{ mt: 2, mb: 2 }} display="flex" justifyContent="space-between" className="float-left">
              <Box width="400px">
                <Box display="flex" alignItems="center">
                  <TextField
                    inputRef={searchRef}
                    placeholder="Filter by Catalog or Group Name"
                    className="textField"
                    id="filterBox"
                    onChange={event => {
                      handleSearch(event.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <Box m={0} className="search-field-icon">
                          <FontAwesomeIcon
                            icon="search"
                            className="small ml-2"
                          />
                        </Box>
                      ),
                      endAdornment:
                        searchString !== '' ? (
                          <Box mr={1} onClick={() => handleClearSearch()}>
                            <FontAwesomeIcon
                              icon="times-circle"
                              className="color-gray-bg small pointer"
                            />
                          </Box>
                        ) : null
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    variant="standard"
                  />
                </Box>
              </Box>
            </Box>
            {selectedCatalogOptions.length > 0 && (
              <Box className="float-left ml-5 pl-5 mt-4 pt-3">
                <Button onClick={() => clearSelectedResults()} className="text-capitalize">
                  Clear Selected
                </Button>
              </Box>
            )}

            {filteredGroups?.length ? (
              <>
                <Box className="view-selected-button">
                  <ViewSelectedResultsButton />
                </Box>
                <Box className="data-table-wrapper" sx={{ mb: 3 }}>
                  <AutoSizer disableHeight>
                    {({ width }) => (
                      <List
                        ref={listRef}
                        height={600}
                        width={width}
                        itemCount={itemCount}
                        className="hide-scrollbars"
                        itemSize={index => {
                          const catalogItemCount = filteredGroups[index]?.catalogs?.length || 1;
                          const extraHeight = catalogItemCount * 42;
                          return extraHeight + 100;
                        }}
                        itemData={filteredGroups}
                      >
                        {CatalogsGroups}
                      </List>
                    )}
                  </AutoSizer>
                </Box>
              </>
            ) : (
              <Box className="clear-both" sx={{ mt: 3 }}>
                No auctions available for {searchString === '' ? 'Sales Results' : 'search string'}
              </Box>
            )}
          </>
        )}
      </Container>
    </Page>
  );
};

export default SessionResults;
